import {AuthService} from "./AuthService";

// Admin-only proxy-canary API client. Delegates to the shared AuthService axios
// layer (Token auth injected per-request); never imports axios directly.
// Mirrors CampaignQualityService / SpecialFieldService conventions.
export class CanaryService {

    url = `admin/canary/`;

    // GET admin/canary/ -> [{host, canary:{provider, rate, enabled}}]
    getRules() {
        return AuthService.apiGet(this.url).then(res => res.data.data);
    }

    // POST admin/canary/ {host, provider, rate, enabled} -> upserts the rule
    saveRule(rule) {
        return AuthService.apiPost(this.url, rule).then(res => res.data.data);
    }

    // DELETE admin/canary/rule/?host=<host> -> removes the rule
    deleteRule(host) {
        return AuthService.apiDelete(this.url + "rule/", {params: {host}}).then(res => res.data);
    }

    // GET admin/canary/providers/ -> [{label, value}] for the dropdown
    getProviders() {
        return AuthService.apiGet(this.url + "providers/").then(res => res.data.data);
    }

    // GET admin/canary/hosts/ -> [{host, proxy_type, proxy_country}, ...] registered sites
    getHosts() {
        return AuthService.apiGet(this.url + "hosts/").then(res => res.data.data);
    }

    // GET admin/canary/metrics/?days=&provider=&host=
    //  -> {rows:[daily canary_metrics docs incl. user/by_reason/samples],
    //      dimensions:{hosts, providers, users:[{id,name}]}}. Both result lenses (A/B cards +
    //      breakdown table) are built client-side from `rows`.
    getMetrics(params = {}) {
        return AuthService.apiGet(this.url + "metrics/", {params: params}).then(res => res.data.data);
    }
}
